<template>
  <v-row v-if="confirmer.active" justify="center">
    <v-dialog
      v-if="confirmer.note_dialog === true"
      v-model="confirmer.active"
      persistent
      max-width="800px"
    >
      <v-card>
        <v-card-title class="headline"> Change message note ?</v-card-title>
        <v-card-text>
          <v-textarea
            v-model="confirmer.note"
            solo
            rows="5"
            clearable
            label="change note"
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" outlined text @click.native="cancel">
            <strong>no</strong>
          </v-btn>
          <v-btn color="green darken-1" outlined text @click.native="confirm">
            <strong>yes</strong>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-else
      v-model="confirmer.active"
      :dark="confirmer.ligth ? false : true"
      persistent
      max-width="500"
    >
      <v-card>
        <v-row justify="center" no-gutters>
          <v-icon large> mdi-check-decagram </v-icon>
          <v-card-title class="headline">
            {{ confirmer.title }}
          </v-card-title>
        </v-row>
        <v-card-text v-if="confirmer.body" class="text-center mt-3">
          <strong>{{ confirmer.body }}</strong>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="green darken-1" outlined text @click.native="cancel">
            <strong>{{ $t("show_box.cancel") }}</strong>
          </v-btn>
          <v-btn color="green darken-1" outlined text @click.native="confirm">
            <strong>{{ $t("show_box.confirme") }}</strong>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  data() {
    return {
      text: "",
    };
  },
  computed: {
    confirmer() {
      return this.$store.state.confirmer;
    },
  },
  methods: {
    confirm() {
      if (this.confirmer.note_dialog)
        this.confirmer.resolve({ state: true, text: this.confirmer.note });
      else this.confirmer.resolve(true);
      this.$store.commit("confirmer/DEACTIVATE");
    },
    cancel() {
      this.confirmer.resolve(false);
      this.$store.commit("confirmer/DEACTIVATE");
    },
  },
};
</script>

<style></style>
